export const getStepProgressItemGlyphicon = (step) => {
  // sub steps
  if (step.path.indexOf('.') >= 0) {
    return 'ba-RadioBullet';
  }

  if (step.isSelected || step.containsSelected) {
    return 'ba-RadioBullet2'; // current step
  } else if (step.isBehind) {
    return 'ba-CompletedSolid';
  }

  // default
  return 'ba-RadioBtnOff';
};
